













































































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyForm from "@/mixins/form";

@Component
export default class extends Mixins(MyForm) {
  tags: any[] = [];

  async mounted() {
    this.spinLoading = true;
    const res1 = await this.$store.dispatch("stadium/getTags", {});
    if (res1 && res1.Data) {
      this.tags = res1.Data;
    }
    const res = await this.$store.dispatch("stadium/discoverydetail", {
      id: this.editId,
    });
    if (res && res.Data) {
      this.formData = res.Data;
    }
    this.spinLoading = false;
  }

  handleSubmit(status: number) {
    let content: string = "";
    if (status === 1) {
      content = "确认存在该场馆吗？";
    } else {
      content = "确认不存在该场馆吗？";
    }
    this.$confirm({
      title: "确认信息",
      content,
      onOk: async () => {
        this.confirmLoading = true;
        const res = await this.$store.dispatch("stadium/discoveryhandle", {
          id: this.editId,
          status,
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success(res.Message);
        } else {
          this.$message.error(res.Message);
        }
        this.confirmLoading = false;
      },
    });
  }
}
